import { normalizeApiError } from '../api/apiError';
import { createReadAsyncThunk } from "../store/createReadAsyncThunk";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { Alumni } from '../../features/updateProfile/api/alumniApi';
import { AlumnusDetails } from "../../features/updateProfile/models/alumniDetails";

interface updateProfileState {
    alumnusDetails: AlumnusDetails | null,

    alumnusDetailsStatus: ApiRequestStatus;
    updateAlumnusDetailsStatus: ApiRequestStatus;
}

const initialState: updateProfileState = {
    alumnusDetails: null,
    alumnusDetailsStatus: ApiRequestStatus.Idle,
    updateAlumnusDetailsStatus: ApiRequestStatus.Idle
}

export const getAlumniDetails = createReadAsyncThunk<AlumnusDetails, string>(
    'alumni/getAlumniDetails',
    async (personId, thunkAPI) => {
        try {
            return await Alumni.getAlumniDetails(personId);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const updateAlumniDetails = createAsyncThunk<boolean, AlumnusDetails>(
    'alumni/updateAlumniDetails',
    async (alumnusDetails, thunkAPI) => {
        try {
            return await Alumni.updateAlumniDetails(alumnusDetails);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const alumniSlice = createSlice({
    name: 'alumniSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getAlumniDetails.pending, (state) => {
            state.alumnusDetailsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getAlumniDetails.fulfilled, (state, action) => {
            state.alumnusDetailsStatus = ApiRequestStatus.Fulfilled;
            state.alumnusDetails = action.payload;
        });
        builder.addCase(getAlumniDetails.rejected, (state) => {
            state.alumnusDetailsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(updateAlumniDetails.pending, (state, action) => {
            state.updateAlumnusDetailsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(updateAlumniDetails.fulfilled, (state, action) => {
            state.updateAlumnusDetailsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(updateAlumniDetails.rejected, (state, action) => {
            state.updateAlumnusDetailsStatus = ApiRequestStatus.Rejected;
        });
    })
})
